var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyCart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 166,
    height: 210,
    viewBox: "0 0 165.759 210",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "empty cart"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\xD1\\xEB\\xEE\\xE9 2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f7f7f7",
    d: "M3.007 198.892c-1.364 1.011-2.6 2.226-2.5 4.164.2 4.121 7.278 5.11 10.172 5.5 5.125.7 10.26.592 15.411.787q28.06 1.062 56.146.4 14.415-.321 28.818-1.047c8.434-.422 17.828.119 25.819-3.139a111.905 111.905 0 0 0 13.9-7c3.722-2.162 8.549-4.225 10.755-8.268 3.867-7.087-9.685-8.487-13.414-9.266-14.662-3.064-29.782-3.609-44.7-4.064a335.848 335.848 0 0 0-45.508 1.419c-18.947 2-39.206 8.411-54.681 20.353Z",
    "data-name": "Path 17149"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3794"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f7f7f7",
    d: "M42.089 117.278h108.56v74.415H42.089z",
    "data-name": "Rectangle 949"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3788"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M150.649 117.278H42.089l14.369-16.609a3.511 3.511 0 0 1 2.656-1.214h104.961a.911.911 0 0 1 .689 1.507Z",
    "data-name": "Path 17150"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3787"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M150.703 116.799H43.795a5.278 5.278 0 0 0-1.464 0 .674.674 0 0 1-.19 0l.482.671 10.592-12.244c1.252-1.447 2.447-2.983 3.774-4.363.969-1.008 2.018-.936 3.235-.936h100.515a20.618 20.618 0 0 1 2.9 0c1.323.2.1 1.4-.409 1.99l-12.119 14.012-1 1.154c-.53.612.687.837 1.074.39l10.91-12.607 2.515-2.908c.418-.483 1.057-1.033 1.02-1.726-.069-1.33-1.418-1.255-2.375-1.255H61.604c-.775 0-1.556-.027-2.331 0-1.957.068-3.073 1.172-4.249 2.531l-12.393 14.327-1.081 1.249c-.338.391.118.671.482.671h104.127c1.4 0 2.852.117 4.246 0 .062-.005.127 0 .19 0 .737-.001.976-.956.108-.956Z",
    "data-name": "Path 17151"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3791"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f7f7f7",
    d: "M42.25 117.278 15.581 127.66v74.415l26.669-10Z",
    "data-name": "Path 17152"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3789"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "m42.023 117.108-23.341 9.089-3.328 1.3c-.843.328-.054.537.455.339l23.341-9.086 3.328-1.3c.843-.331.054-.54-.455-.342Z",
    "data-name": "Path 17153"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3790"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M42.889 191.903v-71.257c0-.347-1.279-.122-1.279.343v71.261c0 .347 1.279.122 1.279-.343Z",
    "data-name": "Path 17154"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3793"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "m42.25 117.279-26.669 10.382-12.782-12.447a2.334 2.334 0 0 1 .809-3.857l21.859-8.2a2.335 2.335 0 0 1 2.425.492Z",
    "data-name": "Path 17155"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m41.561 117.547-25.98 10.113-10.859-10.774a2.334 2.334 0 0 1 .809-3.857l7.559-2.806c3.7-1.372 8.163-4.186 12.24-3.315 2.923.627 15.922 10.36 16.231 10.639Z",
    "data-name": "Path 17156"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3792"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "m41.979 116.949-23.341 9.086-3.328 1.3.859.061-9.8-9.54-2.283-2.223a3.945 3.945 0 0 1-1.288-1.683c-.587-2.18 2.286-2.714 3.741-3.259l15.545-5.827c1.193-.447 3.433-1.818 4.737-1.229a5.393 5.393 0 0 1 1.356 1.125l2.241 2.126 11.242 10.666c.378.359 1.588-.148 1.178-.537l-10.58-10.044c-1.251-1.187-2.457-2.471-3.777-3.583-1.631-1.374-3.324-.543-5.023.094l-16.38 6.141a27.105 27.105 0 0 0-4.192 1.623 2.715 2.715 0 0 0-.792 4.111 16.218 16.218 0 0 0 1.166 1.151l11.73 11.422a.8.8 0 0 0 .859.061l23.341-9.086 3.328-1.3c.824-.318.09-.906-.539-.656Z",
    "data-name": "Path 17157"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3807"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M15.083 127.66H123.98v74.415H15.083z",
    "data-name": "Rectangle 950"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M123.98 129.202c-3.493 5.207-7.517 12.211-10.018 16.683a8.58 8.58 0 0 1-7.472 4.394l-91.407.2v51.6h108.9Z",
    "data-name": "Path 17158"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3796"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f7f7f7",
    d: "m150.651 117.278-26.669 10.382v74.415l26.669-10Z",
    "data-name": "Path 17159"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "m150.65 141.948-8.856 3.555a7.255 7.255 0 0 1-8.5-2.373l-9.311-12.386v71.332l26.669-10Z",
    "data-name": "Path 17160"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3795"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M123.342 131.012v68.459c0 .274 1.279.073 1.279-.343v-68.459c0-.273-1.279-.073-1.279.343Z",
    "data-name": "Path 17161"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3797"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M14.823 127.973h103.638c1.713 0 3.525.169 5.233 0a11.657 11.657 0 0 0 2.831-1l7.747-3.016 15.615-6.078 1-.391c.838-.326.062-.622-.475-.413l-11.987 4.667c-4.76 1.853-9.666 3.5-14.334 5.58-.633.281.058.015.083.03-.111-.065-.458 0-.584 0H35.799c-6.707 0-13.448-.2-20.153 0h-.3c-.417 0-1.378.625-.524.625Z",
    "data-name": "Path 17162"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3798"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M149.998 140.454v51.672l.364-.428-12.1 4.537c-4.744 1.779-9.611 3.373-14.276 5.352-.551.234.137.041-.037.018a4.837 4.837 0 0 0-.614 0H17.756a13.137 13.137 0 0 0-2.313 0 1.664 1.664 0 0 1-.3 0l.592.423v-54.372c0-.671-1.3-.483-1.3.1v54.371c0 .332.309.423.592.423h103.516a40.671 40.671 0 0 0 5.341 0 13.265 13.265 0 0 0 2.64-.938l7.654-2.87 15.743-5.9 1.015-.38a.573.573 0 0 0 .364-.428v-51.675c0-.671-1.3-.483-1.3.1Z",
    "data-name": "Path 17163"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3800"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M123.981 127.664h-108.9l-14.358 16.6a.742.742 0 0 0 .561 1.227h106.939a.742.742 0 0 0 .561-.257Z",
    "data-name": "Path 17164"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M123.982 127.664H16.158c-1.659 3.206-3.253 6.454-5.006 9.61-1.077 1.94-1.284 5.1 1.864 5.1h92.468a6.948 6.948 0 0 0 4.741-1.869Z",
    "data-name": "Path 17165"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3799"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M124.217 127.248h-108.2a2.158 2.158 0 0 0-1.476.287 9.406 9.406 0 0 0-1.062 1.228l-2.241 2.592L.574 143.687c-.759.878-.95 2.1.592 2.217.59.043 1.2 0 1.792 0h103.421c.519 0 1.049.033 1.567 0 1.256-.079 1.829-1.063 2.586-1.938l11.2-12.949 2.775-3.208c.512-.592-.718-.676-1.048-.294l-10.629 12.29c-1.489 1.721-2.928 3.507-4.476 5.174-.2.221.307.036-.113.1a6.843 6.843 0 0 1-.928 0H4.949a21.42 21.42 0 0 1-2.977 0c-.109-.016-.351.057-.447 0-.827-.484.428-1.478.71-1.8l12.293-14.214 1.08-1.248-.759.267H110.3c4.4 0 8.868.243 13.26 0h.19c.544-.008 1.329-.836.467-.836Z",
    "data-name": "Path 17166"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3802"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "m150.65 117.278-26.669 10.381 14.889 14.388a1.167 1.167 0 0 0 1.221.253l24.273-9.1a1.167 1.167 0 0 0 .684-1.5 1.18 1.18 0 0 0-.272-.42Z",
    "data-name": "Path 17167"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m149.782 117.616-25.478 10.173 13.4 13.531a1.017 1.017 0 0 0 1.1.239l10.049-3.939 6.08-2.384c1.986-.779 4.765-1.719 4.523-4.4a5.448 5.448 0 0 0-1.742-3.06c-.913-.966-7.487-9.698-7.932-10.16Z",
    "data-name": "Path 17168"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3801"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "m150.361 116.878-23.341 9.086-3.328 1.3a.463.463 0 0 0-.2.781l11 10.63a47.359 47.359 0 0 0 3.887 3.756c1.3.992 3.307-.216 4.622-.708l17.433-6.535a43.4 43.4 0 0 0 4.219-1.582c2.541-1.272.065-3.245-1.062-4.363l-12.358-12.246c-.429-.425-1.635.112-1.167.576l10.239 10.149 2.716 2.692a7.653 7.653 0 0 1 1.158 1.146c.931 1.506-2.4 2.107-3.312 2.449l-16.75 6.279-2.972 1.114a4.614 4.614 0 0 1-1.323.5c-.43-.023-.932-.679-1.211-.948l-2.327-2.249-11.816-11.423-.2.781 23.341-9.086 3.328-1.3c.814-.319.101-1.062-.576-.799Z",
    "data-name": "Path 17169"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3806"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3803"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M115.627 147.227v12.643c0 .691 1.3.519 1.3-.086v-12.643c0-.691-1.3-.519-1.3.086Z",
    "data-name": "Path 17170"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3804"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M115.637 162.576v1.99c0 .536 1.279.268 1.279-.157v-1.994c0-.536-1.279-.268-1.279.158Z",
    "data-name": "Path 17171"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3805"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M115.63 166.867v5.193c0 .649 1.293.445 1.293-.107v-5.194c0-.649-1.293-.444-1.293.108Z",
    "data-name": "Path 17172"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3816"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3815"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3808"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "m129.788 186.125 11.545-3.729c.768-.248.553-1.109-.23-.856l-11.544 3.724c-.768.248-.554 1.109.229.857Z",
    "data-name": "Path 17173"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3809"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "m129.767 181.548 11.49-3.763c.748-.245.587-.929-.181-.677l-11.49 3.763c-.748.245-.587.928.181.677Z",
    "data-name": "Path 17174"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3810"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "m129.756 177.108 11.438-3.8c.738-.245.6-.847-.159-.595l-11.438 3.8c-.738.245-.6.847.159.595Z",
    "data-name": "Path 17175"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3814"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3811"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "m129.802 189.591 2.549-.814c.264-.084.6-.319.513-.643-.082-.307-.5-.384-.766-.3l-2.549.814c-.264.084-.6.318-.513.643.082.3.5.382.766.3Z",
    "data-name": "Path 17176"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3812"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "m134.229 187.975 2.572-.822c.166-.053.631-.2.562-.459s-.566-.164-.716-.116l-2.572.822c-.166.053-.631.2-.562.458s.565.164.716.116Z",
    "data-name": "Path 17177"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3813"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "m138.761 186.591 2.6-.829c.2-.064.622-.238.545-.522s-.542-.24-.733-.179l-2.6.829c-.2.064-.622.237-.546.522s.542.24.733.179Z",
    "data-name": "Path 17178"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3818",
    transform: "translate(54.145 165.556)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3817"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M1.21 17.719c3.4-3.962 9.024-6.258 14.142-6.472a21.9 21.9 0 0 1 11.223 2.587 20.11 20.11 0 0 1 3.959 2.77c.424.424 1.631-.11 1.168-.574a21.215 21.215 0 0 0-10.311-5.248A22.77 22.77 0 0 0 3.45 14.427a17.956 17.956 0 0 0-3.32 2.888c-.53.617.682.866 1.078.406Z",
    "data-name": "Path 17179"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M5.591 1.518a2.058 2.058 0 0 1-1.316 2.468 1.815 1.815 0 0 1-2.187-1.344 1.7 1.7 0 0 1-.025-.124A2.058 2.058 0 0 1 3.379.05a1.815 1.815 0 0 1 2.187 1.344c.01.043.018.082.025.124Z",
    "data-name": "Path 17180"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.82,
    cy: 2.03,
    fill: "#262626",
    "data-name": "Ellipse 105",
    rx: 1.82,
    ry: 2.03,
    transform: "translate(27.194 .674)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3819"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M94.779 120.433c-5.86.7-12.166 1.474-17.745-.961-4.633-2.022-8.486-6.274-8.188-11.589.31-5.523 4.333-9.844 9.206-12a28.738 28.738 0 0 1 17.277-1.465c2.725.562 6.01 1.367 8.284 3.062 1.9 1.418 2.654 3.946.812 5.721a11.746 11.746 0 0 1-5.116 2.376c-1.843.506-3.714.978-5.6 1.3-9.6 1.67-20.5.084-28.031-6.515a18 18 0 0 1-6.352-13.145c-.016-5.151 2.893-9.841 6.8-13.019 7.819-6.359 18.692-8.17 28.488-8.215a89.692 89.692 0 0 1 14.461 1.162 27.467 27.467 0 0 1 7.559 1.913c2.377 1.132 4.79 3.5 4.158 6.38-.6 2.726-3.741 3.59-6.074 4.269a39.208 39.208 0 0 1-9.258 1.421 106.994 106.994 0 0 1-17.708-.908 95.443 95.443 0 0 1-16.359-3.342 35.589 35.589 0 0 1-10.945-5.19 17.785 17.785 0 0 1-6.667-9.423 21.317 21.317 0 0 1 .751-13.232c3.206-8.232 11.282-13.313 19.257-16.188a86.13 86.13 0 0 1 34.219-4.559 89.853 89.853 0 0 1 17.407 2.853 73.024 73.024 0 0 1 8.568 2.8c2.328.935 4.7 2 5.883 4.359 2.287 4.544-2.242 8.848-5.857 10.89-3.967 2.24-8.6 3.562-12.986 4.726a87.8 87.8 0 0 1-17.927 2.465c-5.75.3-11.522.509-17.281.416-11.091-.178-22.467-1.582-32.5-6.6-8.715-4.359-17.3-13.24-15.119-23.857 1.029-5.011 4.77-9.35 8.619-12.511a45.257 45.257 0 0 1 13.5-7.35c9.986-3.6 20.737-4.848 31.278-5.467a152.386 152.386 0 0 1 35.151 1.891 154.547 154.547 0 0 1 17.342 4.078c.361.107 1.511-.443 1.026-.587A155.349 155.349 0 0 0 70.935 2.93C60.472 5.099 49.527 8.968 42.179 17.1c-3.6 3.99-6.054 8.865-5.471 14.35a22.211 22.211 0 0 0 7.2 13.675c8.57 7.982 21.147 10.9 32.475 11.9a153.7 153.7 0 0 0 18.3.349 159.28 159.28 0 0 0 19.467-1.427 81.223 81.223 0 0 0 15.819-4.243c4.12-1.536 8.488-3.737 10.759-7.693a6.227 6.227 0 0 0 .246-6.356c-1.259-2.226-3.472-3.28-5.742-4.2a82.585 82.585 0 0 0-18.1-4.888 91.588 91.588 0 0 0-37.7 1.937c-8.957 2.375-18.449 6.388-23.855 14.327-5.058 7.429-5.356 18.257 1.033 25.009a28.549 28.549 0 0 0 11.087 6.737 82.551 82.551 0 0 0 15.727 3.809 118.8 118.8 0 0 0 19.572 1.479 48.333 48.333 0 0 0 9.035-.876 23.407 23.407 0 0 0 7.707-2.64 4.725 4.725 0 0 0 2.3-5.177c-.61-2.492-2.9-4.125-5.163-5.029a34.958 34.958 0 0 0-7.782-1.755q-3.861-.583-7.759-.855c-10.36-.718-21.315.217-30.7 4.994-4.564 2.324-8.737 5.623-11.021 10.31a15.921 15.921 0 0 0 .8 15.053c5.328 9.2 17.076 12.6 27.1 12.263 3.573-.118 23.491-2.145 18.636-9.733-1.466-2.291-4.691-3.195-7.146-3.919a34.493 34.493 0 0 0-8.423-1.406c-5.48-.209-11.329.9-15.988 3.909-4.272 2.758-7.47 7.491-6.99 12.75.477 5.22 4.824 9.055 9.516 10.743 5.591 2.011 11.716 1.275 17.477.583.595-.071 1.083-.754.191-.647Z",
    "data-name": "Path 17181"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCart);
export default __webpack_public_path__ + "static/media/empty-cart.8fb40c859024ba82588b7e65f992bc40.svg";
export { ForwardRef as ReactComponent };